module.exports = __webpack_public_path__ + "img/logo.8cc97c0a.png";